import { Alert, Box, Button, Container, Grid, TextField } from "@mui/material";
import React from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import TicketRetrievalEndpoints from "../../api/TicketRetrievalEndpoints";
import config from "../../config";
import { EcommerceEventList } from "../../models/Event";
import { SendOrderLinksRequest } from "../../requests/OrderRequests";
import { getErrorMessage } from "../../utils/helpers";
import toast from "../../utils/toast";

type Props = {
    eventList: EcommerceEventList;
};

const RetrievePreviousOrders = ({ eventList }: Props) => {
    const [request, setRequest] = React.useState<SendOrderLinksRequest>({
        email: "",
    });
    const [loading, setLoading] = React.useState(false);

    const { executeRecaptcha } = useGoogleReCaptcha();

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        setRequest({ ...request, email: e.target.value });
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (!executeRecaptcha) return;

        try {
            setLoading(true);
            const token = await executeRecaptcha("send_order_links");
            console.log(token);
            await TicketRetrievalEndpoints.sendOrderLinks(
                { ...request, reCaptchaResponse: token },
                eventList.cartUrl ?? "",
            );
            toast.success("Email has been sent.");
        } catch (err) {
            toast.error(getErrorMessage(err));
        } finally {
            setRequest({ email: "" });
            setLoading(false);
        }
    }

    return (
        <Container maxWidth="sm">
            <form onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Alert severity="info">
                            Enter your email below to retrieve previous orders.
                        </Alert>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", justifyContent: "center" }}
                    >
                        <TextField
                            variant="standard"
                            label="Email"
                            placeholder="Email"
                            value={request.email}
                            onChange={onChange}
                            required
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", justifyContent: "center" }}
                    >
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading}
                        >
                            Send Orders
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

export default RetrievePreviousOrders;
